export const QUOTE_MESSAGE = 'Estás a punto de iniciar tu plan de ahorro';